module.exports = __webpack_public_path__ + "img/3.53ccd432.jpg";